import { Injectable } from '@angular/core';
import { BooleanCons, PATTERNS } from '../constants/const';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class PatternService {
  constructor(private commonService: CommonService) {}
  inputNumbersOnly(event: any, numbers: any): boolean {
    const flag = this.commonService.validateAndValue([
      event.keyCode === 48,
      numbers === '',
    ]);

    return this.commonService.calculateTernary(
      flag,
      BooleanCons.false,
      PATTERNS.onlyNumbers.test(event.key)
    );
  }

  inputValidation(event: any, data: any, regex: RegExp): boolean {
    const flag = this.commonService.validateAndValue([
      event.keyCode === 48,
      data === '',
    ]);
    return this.commonService.calculateTernary(
      flag,
      BooleanCons.false,
      regex.test(event.key)
    );
  }
}
